"use strict";

/**
* @ngdoc directive
* @name nms.directive:locationsPermissions
* @description Diretiva para criar as permissões de localidades.
*
* Atributos:
* # id      - Obrigatório      - Identificador. Utilizado para a criação de ids no html de forma a evitar duplicidade
*                                quando diretiva é usada mais de uma vez na página.
*
* # owner   - Obrigatório      - Objeto utilizado para comunicação entre a diretiva e seu pai, contendo o modelo de dados.
*           - Estrutura        - {model: {}}
*
*/
var app = angular.module("nms");

app.directive("locationsPermissions", function() {
    return {
        restrict: "E",
        templateUrl: "templates/features/management/permissions/location.html",
        controller: "ManagePermissionsLocationsController",
        scope: {
            id: "@",
            owner: "="
        }
    };
});
